module.exports = __webpack_public_path__ + "img/elantra6.eae6e11d.jpeg";